import React from "react";
import { Grid, Card, CardActionArea, Box, Typography } from "@mui/material";

interface Member {
  name: string;
  inst: string;
  img: string;
  text: string;
}

interface MembersSectionProps {
  members: Member[];
  onMemberClick: (member: Member) => void;
}

const MembersSection: React.FC<MembersSectionProps> = ({ members, onMemberClick }) => {
  return (
    <Grid container justifyContent="center" spacing={3}>
      {members.map((member, index) => (
        <Grid item xs={6} md={3} key={index}>
          <Card elevation={0} sx={{ background: "transparent" }}>
            <CardActionArea onClick={() => onMemberClick(member)}>
              <Box textAlign="center">
                <Box
                  component="img"
                  src={member.img}
                  alt={member.name}
                  sx={{
                    width: 120,
                    height: 120,
                    borderRadius: "50%",
                    objectFit: "cover",
                    objectPosition: member.name === "吉田雪乃" ? "center top" : "center center",
                    mb: 1,
                  }}
                  {...({ loading: "lazy", decoding: "async" } as any)}
                />
                <Typography variant="body2" sx={{ color: "#607d7d" }}>
                  {member.inst}
                </Typography>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  sx={{ color: "#53696d" }}
                >
                  {member.name}
                </Typography>
              </Box>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default MembersSection;